export default "/button_co_on_02.png";